const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_EXAMPLE = (state, payload) => {
  state.example = payload
}

export default {
  SET_LIST,
  SET_EXAMPLE
}



// WEBPACK FOOTER //
// ./src/features/invoice_requests/store/mutations.js